import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import SubstitutionList, { DispatchProps, OwnProps, StateProps } from './SubstitutionList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getSubstitutions } from 'src/store/actions/substitution-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.substitutions.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getSubstitutions(params)),
    };
}

const SubstitutionListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(SubstitutionList);

export default SubstitutionListScreen;
